<div class="progress-boxes">
    <div class="box" *ngFor="let color of getBoxes(); let i = index" [ngStyle]="{'background-color': color}"
        [class.all-rounded]="borderStyle === 'all-rounded'"
        [class.outer-rounded-first]="borderStyle === 'outer-rounded' && i === 0"
        [class.outer-rounded-last]="borderStyle === 'outer-rounded' && i === total - 1"
        [ngClass]="{'smallDimensions': smallDimensions}"></div>
</div>